import { stripTags } from "functions/stripTags";
import sourceflowEnums from "@/sourceflow.enums";
import { useMemo } from "react";

export const JobPostingSchema = ({ job, jobType }) => {
  const unitText = useMemo(() => {
    if (job?.salary_package?.toLowerCase().includes("year")) {
      return "YEAR";
    }
    if (job?.salary_package?.toLowerCase().includes("month")) {
      return "MONTH";
    }
    if (job?.salary_package?.toLowerCase().includes("hour")) {
      return "HOUR";
    }
    return "YEAR";
  }, [job?.salary_package]);

  const value = useMemo(() => {
    return job?.salary_package
      .split(/[\s-]+/)
      .map((s) => {
        const v = s.replace(/^\D+/g, "");
        return v.endsWith("k") ? parseInt(v) * 1000 : parseInt(v);
      })
      .filter((s) => !!s);
  }, [job?.salary_package]);

  const currency = useMemo(() => {
    return (job?.salary_package?.match(
      /[$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/,
    ) ?? ["£"])[0];
  }, [job?.salary_package]);

  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    title: `${job.title}`,
    description: `${stripTags(job.description)}`,

    identifier: {
      "@type": "PropertyValue",
      name: sourceflowEnums.seo.siteName,
      value: `${job.external_reference}`,
    },
    datePosted: `${job.created_at}`,
    validThrough: `${job.expires_at}`,
    hiringOrganization: {
      "@type": "Organization",
      name: sourceflowEnums.seo.siteName,
      sameAs: sourceflowEnums.seo.baseURL,
      logo: sourceflowEnums.seo.logo,
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        postalCode: `${job.location}`,
        addressRegion: `${job.location}`,
        streetAddress: `${job.location}`,
        addressLocality: `${job.location}`,
        addressCountry: `${job.addresses}`,
      },
    },
    employmentType: jobType,
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: currency,
      value: {
        '@type': 'QuantitativeValue',
        "value":value,
        'unitText': unitText
    },
      unitText: unitText,
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />;
};

export default JobPostingSchema;
